import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Style from '../assets/css/landing.module.css';

const LANGUAGE_CYCLE_DELAY = 2500;
const FADE_TRANSITION_DELAY = 500;

const Landing = () => {
    const { t } = useTranslation();
    const languages = useMemo(() => ['en', 'es', 'fr', 'zh', 'de', 'mix', 'zap', 'mya'], []);
    const [languageIndex, setLanguageIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    const nextLanguage = useCallback(() => {
        setIsVisible(false);
        setTimeout(() => {
            setLanguageIndex(prev => (prev + 1) % languages.length);
            setIsVisible(true);
        }, FADE_TRANSITION_DELAY);
    }, [languages.length]);

    useEffect(() => {
        const intervalId = setInterval(nextLanguage, LANGUAGE_CYCLE_DELAY);
        return () => clearInterval(intervalId);
    }, [nextLanguage]);

    const titleClass = `${Style.title} ${isVisible ? Style.fadeIn : Style.fadeOut}`;
    const currentLanguage = languages[languageIndex];

    return (
        <section className={Style.landing}>
            <h1 className={titleClass}>
                {t('welcome', { lng: currentLanguage })}
            </h1>
            <img
                src="solMixteco.webp"
                alt="Constellation illustration"
                className={Style.constellation}
                loading="lazy"
            />
            <img
                src="mountain.webp"
                alt="Mountain background"
                className={Style.backgroundImage}
                loading="lazy"
            />
            {/* Flecha animada hacia abajo */}
            <div className={Style.arrowContainer}>
                <div className={Style.arrow}></div>
            </div>
        </section>
    );
};

export default React.memo(Landing);